import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/shared/components'
import { CouriersPage } from '@/pages/couriers/CouriersPage'

export const Route = createFileRoute('/couriers/')({
  component: () => (
    <RequirePermission section="couriers" action="view">
      <CouriersPage />
    </RequirePermission>
  ),
})
